export function Skeleton({ className }: { className?: string }) {
	return <div className={`animate-pulse rounded bg-surface-2 ${className ?? "h-4 w-full"}`} />;
}

export function TableSkeleton({ rows = 5, cols = 4 }: { rows?: number; cols?: number }) {
	return (
		<div className="overflow-hidden rounded-lg border border-line">
			<div className="border-b bg-surface px-4 py-3">
				<div className="flex gap-4">
					{Array.from({ length: cols }).map((_, i) => (
						<Skeleton key={`h-${i}`} className="h-4 w-24" />
					))}
				</div>
			</div>
			{Array.from({ length: rows }).map((_, i) => (
				<div key={`r-${i}`} className="flex gap-4 border-b border-line px-4 py-3">
					{Array.from({ length: cols }).map((_, j) => (
						<Skeleton key={`c-${j}`} className="h-4 w-20" />
					))}
				</div>
			))}
		</div>
	);
}

export function CardSkeleton() {
	return (
		<div className="rounded-lg border border-line p-6">
			<Skeleton className="mb-4 h-6 w-32" />
			<Skeleton className="mb-2 h-4 w-full" />
			<Skeleton className="mb-2 h-4 w-3/4" />
			<Skeleton className="h-4 w-1/2" />
		</div>
	);
}
